const translations = {
    title: 'Aktywuj konto',
    description: '',
    canonical: 'string',
    image: '',
    robots: 'noindex, nofollow',
};

export default translations;